import React from "react";
import {component_tool, utils_tool} from '@/tool';
import {WizTableForm} from '@/containers/common';
import moment from "moment";
import '@/styles/containers/train/credit/subjectcreditrecord/index.less'

let {$$, checkStrLength} = utils_tool;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
};
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

let {WizDataTable, WizButton,WizPopover} = component_tool

const organizationConfig = WizTableForm.Config.organization(this, {apiParams: {state: 1}})
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })

export const commentDetailColumns = (self, employees, other) => {
  let columns = [
    {
      title: '考核内容',
      dataIndex: 'head',
      key: 'head',
      width: 250,
      ellipsis: true,
      render: text => <a>{text}</a>,
    },
    {
      title: '状态',
      dataIndex: 'state',
      key: 'state',
      width: 80,
      dict: [
        {code: 1, codeName: '有效'},
        {code: 0, codeName: '无效'}
      ],
      render: (text, record) => (
        <>{record.state == 1 ? "有" : "无"}效</>
      ),
    },
    {
      title: '最新修改时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 200,
      render: (text, record) => (
        <>{record && record.updateTime ? formatterDate(record.updateTime) : formatterDate(new Date())}</>
      ),
    },
  ];
  return columns;
}

export const studentCommentColumns = (self, employees, other) => {
  let columns = [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "姓名",
      name: "fullName",
      tableItem: {
        width: 100,
      },
      searchItem: {}
    },
    {
      title: "账号",
      name: "userName",
      tableItem: {
        width: 100,
      },
      searchItem: {}
    },
    {
      title: "手机号",
      name: "mobile",
      tableItem: {
        width: 120,
      },
    },
    {
      title: "身份证号/工号",
      name: "idCard",
      tableItem: {
        width: 150,
      },
    },
    {
      title: '任职',
      name: 'userIdentityInfos',
      tableItem: {
        width: 150,
        // ellipsis: true,
        render: (text, record) => {
          let contextList = text && text.split(',').length ? text.split(',') : []
          let content = [];
          let title = ''
          contextList && contextList.length && contextList.map((d, index) => {
            if (index === 0) {
              title = d
            }
            content.push(<p key={index}>{d}</p>)
          })
          let _titleView = []
          _titleView.push(title)
          if (contextList && contextList.length > 1) {
            _titleView.push(<span className='wiz-press-font-color'> ...</span>)
          }
          return (
            <WizPopover content={content} placement="rightTop">
              {_titleView}
            </WizPopover>
          )
        }
      }
    },

    // {
    //   title: "用户属性",
    //   name: "userType",
    //   dataIndex: "userType",
    //   tableItem: {
    //     width: 100,
    //   },
    //   dict: [
    //     {code: 0, codeName: "学员"},
    //     {code: 1, codeName: "SGM总部"},
    //     {code: 2, codeName: "SGM区域"},
    //     {code: 3, codeName: "供应商"}
    //   ]
    // },
    // {
    //   title: "账号状态",
    //   name: "userStatus",
    //   dataIndex: "userStatus",
    //   tableItem: {
    //     width: 100,
    //   },
    //   dict: [
    //     {code: 0, codeName: "禁用"},
    //     {code: 1, codeName: "激活"}
    //   ]
    // },
    // {
    //   title: "组织名称",
    //   name: "orgName",
    //   tableItem: {
    //     width: 180,
    //   }
    // },
    // {
    //   title: "组织编码",
    //   name: "orgCode",
    //   tableItem: {
    //     width: 150,
    //   },
    // },
    // {
    //   title: "岗位",
    //   name: "positionName",
    //   tableItem: {
    //     width: 150,
    //   }
    // },
    // {
    //   title: "任职状态",
    //   name: "jobState",
    //   dict: [
    //     {code: 0, codeName: '离职'},
    //     {code: 1, codeName: '在职'},
    //   ],
    //   tableItem: {
    //     width: 100,
    //   },
    // },
    {
      title: "组织",
      name: "orgId",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
        selectType: 'radio',
      }
    },
    {
      title: '岗位',
      name: 'positionId',
      searchItem: {
        ...positionConfig,
        diy: WizTableForm,
        selectType: 'radio'
      },
    },
    {
      title: "评语状态",
      name: "state",
      dict: [
        {code: 1, codeName: "待审核"},
        {code: 2, codeName: "已通过"},
        {code: 3, codeName: "驳回"}
      ],
      searchItem: {
        type: "select"
      },
      tableItem: {
        width: 100,
      },
    },
    {
      title: '评语提交时间',
      dataIndex: 'submitTime',
      name: 'submitTime',
      tableItem: {
        width: 150,
        render: (text, record) => (
          <>{record && record.submitTime ? formatterDate(record.submitTime) : ''}</>
        ),
      },
    },
    {
      title: "提交人姓名",
      name: "submiterFullName",
      tableItem: {
        width: 120,
      }
    },
    {
      title: "提交人账号",
      name: "submiterUserName",
      tableItem: {
        width: 100,
      }
    },
    {
      title: '操作',
      tableItem: {
        width: 200,
        render: (text, record) => (
          <WizDataTable.Oper>
            <WizButton type="link" onClick={e => self._openStudentCommentModel(record)}>查看评语</WizButton>
            {/*<WizButton type="link" onClick={e => self._openUserIdentityModel(record)}>查看任职</WizButton>*/}
          </WizDataTable.Oper>
        )
      }
    }
  ];

  return columns;
}


export const studentCommentExcelColumns = [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '姓名',
    field: 'fullName',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '账号',
    field: 'userName',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '身份证号/工号',
    field: 'idCard',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '手机号',
    field: 'mobile',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '任职',
    field: 'userIdentityInfos',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  // {
  //   headerName: '用户属性',
  //   field: 'userTypeName',
  //   width: 12,
  //   cellStyle: {
  //     textAlign: 'center',
  //   },
  //   style: {
  //     alignment: {vertical: 'bottom', horizontal: 'left'},
  //   },
  // },
  // {
  //   headerName: '账号状态',
  //   field: 'userStatusName',
  //   width: 12,
  //   cellStyle: {
  //     textAlign: 'center',
  //   },
  //   style: {
  //     alignment: {vertical: 'bottom', horizontal: 'left'},
  //   },
  // },
  // {
  //   headerName: '组织名称',
  //   field: 'orgName',
  //   width: 20,
  //   cellStyle: {
  //     textAlign: 'center',
  //   },
  //   style: {
  //     alignment: {vertical: 'bottom', horizontal: 'left'},
  //   },
  // },
  // {
  //   headerName: '组织代码',
  //   field: 'orgCode',
  //   width: 15,
  //   cellStyle: {
  //     textAlign: 'center',
  //   },
  //   style: {
  //     alignment: {vertical: 'bottom', horizontal: 'left'},
  //   },
  // },
  // {
  //   headerName: '岗位',
  //   field: 'positionName',
  //   width: 15,
  //   cellStyle: {
  //     textAlign: 'center',
  //   },
  //   style: {
  //     alignment: {vertical: 'bottom', horizontal: 'left'},
  //   },
  // },
  // {
  //   headerName: '任职状态',
  //   field: 'jobStateName',
  //   width: 12,
  //   cellStyle: {
  //     textAlign: 'center',
  //   },
  //   style: {
  //     alignment: {vertical: 'bottom', horizontal: 'left'},
  //   },
  // },
  {
    headerName: '评语状态',
    field: 'stateName',
    width: 12,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '评语提交时间',
    field: 'submitTime',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '提交人姓名',
    field: 'submiterFullName',
    width: 15,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '提交人账号',
    field: 'submiterUserName',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  }
];
